// extracted by mini-css-extract-plugin
export default {"tabPanel":"TabPanel_tabPanel__qAdg8"};